import * as React from "react";
import { ESharedComponent } from "../../../../../services/UI/State/ESharedComponent";
import { ILogState } from "../../ILogState";
import { State } from "source/app/services/UI/State/State";
import { Switch } from "../../../Dreams/DreamTools/Switch/Switch";

export const FilterGoalCardsSwitch = ({
    isChecked,
    setIsChecked,
}: {
    isChecked: boolean;
    setIsChecked: (value: boolean) => void;
}) => {
    return (
        <Switch
            label="Filter goal cards"
            onChange={(value: boolean) => {
                const log = State.ReadClass<ILogState>(
                    ESharedComponent.Log
                );

                if (log) {
                    const filterState = {
                        LogInpEntryText: "",
                        clickedGoalId: undefined,
                    };

                    log.setState(
                        value === false
                            ? { ...filterState, inpKips: "10" }
                            : filterState
                    );
                }

                setIsChecked(value);
                document.getElementById("target_logInputEntryText")?.focus();
            }}
            isChecked={isChecked}
        />
    );
};
